import { ACTIONS_TYPES } from "../Reducers/inputControlReducer";

export function setDefaults(payload) {
    return {
        type: ACTIONS_TYPES.SET_DEFAULTS,
        payload,
    };
}
